import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row } from 'react-bootstrap';
import { useImageSrc, useSite } from './content/context';
import { ChangePhotoButton, EditableText } from './edit/primitives';

function Bio() {
  const { data, edit } = useSite();
  const imageSrc = useImageSrc();
  const { bio } = data;
  const background = imageSrc(bio.backgroundImage);
  // Blank lines in the bio text separate paragraphs.
  const paragraphs = (bio.text ?? '').split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean);

  return (
    <Row className="mb-3">
      <Col>
        <div
          className="bio-background"
          style={background ? { backgroundImage: `url("${encodeURI(background)}")` } : undefined}
        >
          <div className="bio-overlay">
            {edit ? (
              <EditableText
                as="p"
                multiline
                label="Bio"
                value={bio.text}
                onChange={(text) => edit.update('bio', { ...bio, text })}
              />
            ) : (
              paragraphs.map((paragraph, index) => <p key={index}>{paragraph}</p>)
            )}
          </div>
          {edit ? (
            <ChangePhotoButton
              label="Change background photo"
              onChange={(backgroundImage) => edit.update('bio', { ...bio, backgroundImage })}
            />
          ) : null}
        </div>
      </Col>
    </Row>
  );
}

export default Bio;
